export default __webpack_public_path__ + "static/media/split-bill-step-2.6b803e82.png";